import React from "react";
import { Grid, Typography } from "@mui/material";
import { t } from "i18next";
import { ProductAccordianProps } from "../../../interfaces/CategoryTransactionInterface";

const ProductAccordian = (props: ProductAccordianProps) => {

    const { item, getFlagStatus } = props;

    return (
        <Grid container className="text_wrap">
            <Grid item xs={12} sm={3} md={3} lg={1} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.store_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{item?.storeCode}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={3} md={3} lg={1} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.seller_name")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{item?.storeName}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={3} md={3} lg={1} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.product_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{item?.productCode}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={3} md={3} lg={1} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.cp_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{item?.cainzProductCode}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.product_name")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{item?.productName}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={3} md={3} lg={1} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.public_flag")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{getFlagStatus(item?.publicFlag) ?? "-"}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={3} md={3} lg={1} mb={1}>
                <Grid>
                    <Typography className="main_content_of_accordion" variant="body1">{t("category_management.category_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography className="main_accordion_data" variant="body1">{item?.productCategory}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ProductAccordian;